import { render } from "./ListaContratacoesVigenciaFinalizadaView.vue?vue&type=template&id=c78ecb64&scoped=true"
import script from "./ListaContratacoesVigenciaFinalizadaView.vue?vue&type=script&lang=js"
export * from "./ListaContratacoesVigenciaFinalizadaView.vue?vue&type=script&lang=js"

import "./ListaContratacoesVigenciaFinalizadaView.vue?vue&type=style&index=0&id=c78ecb64&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78ecb64"]])

export default __exports__